import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PatternImg from "images/png/rated-playlist-background-pattern.png";
import PrimaryButton from "components/buttons/primary-button";
import { ReactComponent as Arrow } from "images/svg/arrowRight.svg";
import PageBanner from "images/png/promo-card-banner.png";
import FAQs from "../FAQs";
import HowItWorks from "../how-it-works";
import { useNavigate } from "react-router-dom";

const Default = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Header>
        <BgHeader src={PatternImg} alt="bg-pattern" />
        <HeaderPart>
          <Typography
            color={Colors.white100}
            size="4xl"
            weight="bold"
            m_size="xl"
            mb="3.2"
            m_mb="1.9"
          >
            Promo Cards
          </Typography>

          <Typography
            color={Colors.white100}
            size="6rem"
            weight="bold"
            m_size="4xl"
            mb="1.6"
          >
            Turn Your Music <LineBreak />
            into a Viral Visual!
          </Typography>
          <Typography size="2xl" color={Colors.grey500} mb="3.2">
            Make your music stand out with{" "}
            <span style={{ color: Colors.grey100, fontWeight: 500 }}>
              eye-catching,
            </span>{" "}
            shareable{" "}
            <span style={{ color: Colors.grey100, fontWeight: 500 }}>
              promo cards
            </span>{" "}
            designed for your music releases.{" "}
            <span style={{ color: Colors.grey100, fontWeight: 500 }}>
              Easily customize, download, and share
            </span>{" "}
            across social media.
          </Typography>
          <PrimaryButton
            onClick={() => {
              navigate("/overview/promo-cards/create");
            }}
            text="Create A Promo Card"
            inset
            sparkle
            icon={<Arrow />}
            iconPosition="right"
            fitContent
            iconSize="2"
          />
        </HeaderPart>
        <HeaderPart>
          <Banner src={PageBanner} alt="promo -banner" />
        </HeaderPart>
      </Header>
      <HowItWorks />
      <FAQs />
    </div>
  );
};

export default Default;

const Header = styled.section`
  display: grid;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 40% 50%;
  padding-bottom: 18rem;
  position: relative;

  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    padding-bottom: 1rem;
  }
`;

const BgHeader = styled.img`
  position: absolute;
  width: 100%;
  top: 18%;
  @media only screen and (max-width: 769px) {
    height: 100%;
    width: 350%;
    top: 0%;
    left: -10%;
  }
`;

const LineBreak = styled.br`
  display: block;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const HeaderPart = styled.div`
  position: relative;
`;

const Banner = styled.img`
  position: absolute;
  height: 60rem;
  top: -19rem;
  left: -16rem;

  @media only screen and (max-width: 769px) {
    position: relative;
    top: 0;
    left: -5rem;
    height: 45rem;
  }
`;
